import {CompanyModel} from '../../models/api/companyModel';
import {LocalApplicationModel} from '../../models/api/localApplicationModel';
import {
  ApiOauthClient,
  ApiOauthClientSecret,
  OauthClientSecretModel,
} from '../../models/api/oauthClientModel';
import {fetchApiAsync} from '../../services/http/http';
import {useSettingsQuery} from '../helpers/useSettingsQuery';

/*
 * Constants.
 */

const oauthClientQueryKeyFactory = {
  all: ['applications'],
  id: (id?: number) => ['oauthClient', {id}],
};

/*
 * Fetchers.
 */

export function useFetchOauthClient(application: LocalApplicationModel | undefined) {
  const {data, asyncStatus, refetch} = useSettingsQuery(
    oauthClientQueryKeyFactory.id(application?.id),
    async ({company, cancelToken}) =>
      application?.oauthClientId
        ? fetchApiAsync(ApiOauthClient, buildOauthClientFetchUrl(company, application.id), {cancelToken})
        : undefined,
  );

  return {oauthClient: data, status: asyncStatus, refetch};
}

export async function fetchOauthClientSecretAsync(
  company: CompanyModel,
  application: LocalApplicationModel | undefined,
): Promise<OauthClientSecretModel | undefined> {
  if (!application) {
    return undefined;
  }

  const response = await fetchApiAsync(
    ApiOauthClientSecret,
    buildOauthClientSecretFetchUrl(company, application.id),
  );
  return response;
}

/*
 * Helpers.
 */

function buildOauthClientFetchUrl(company: CompanyModel, applicationId: number) {
  return `${company.url}/local_applications/${applicationId}/oauth_client`;
}

function buildOauthClientSecretFetchUrl(company: CompanyModel, applicationId: number) {
  return `${buildOauthClientFetchUrl(company, applicationId)}/client_secret`;
}
